import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGas: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGas"><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H15V9H18.5V16.5H20.5V8.33402L17.6908 5.80575L18.6943 4.69081L22 7.66598V18H17V10.5H15V19.5H16V21H2V19.5H3V3ZM6 9H12V10.5H6V9Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGas;
